export default "__VITE_ASSET__b309a9df__"